<template>
  <v-container>
    <v-row>
      <v-col class="text-subtitle-1">{{ title }}</v-col>
    </v-row>
    <v-row>
      <v-col class="font-weight-bold text-right">
        établissement:
      </v-col>
      <v-col>
        {{ dossier && dossier.officine ? dossier.officine.denomination : "" }}
      </v-col>
      <v-col class="font-weight-bold text-right">date de la demande: </v-col>
      <v-col>{{ getDate(dossier.dateDepot) }}</v-col>
    </v-row>
    <v-row>
      <v-col class="font-weight-bold text-right">demandeur: </v-col>
      <v-col>{{ dossier ? dossier.demandeur : "" }}</v-col>
      <v-col class="font-weight-bold text-right">
        type de la demande:
      </v-col>
      <v-col>
        {{ dossier.premiereDemande ? "Première demande" : "Renouvellement" }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import common from "@/common";

export default {
  name: "ResumeDossier",
  props: ["dossier", "title"],
  methods: {
    getDate(timestamp) {
      return common.formatDate(timestamp);
    }
  }
};
</script>

<style></style>
